<ng-container *ngIf="languageService.translationLoaded$ | async">
    <router-outlet></router-outlet>
</ng-container>

<!--<app-config></app-config>-->

<p-toast key="custom-toast" [baseZIndex]="99999"></p-toast>
